<template>
    <div>
        <div class="orderdetails_head_content">
            <table>
                <colgroup>
                    <col width="11.5873%">
                    <col width="21.746%">
                    <col width="11.5873%">
                    <col width="21.746%">
                    <col width="11.5873%">
                    <col width="21.746%">
                </colgroup>
                <tbody>
                    <tr>
                        <th><span>订单号：</span></th>
                        <td><span>{{orderinfo.orderdno}}</span><small style="color: red;" v-if="orderinfo.batchcost >= 0"> (特批价)</small></td>
                        <th><span>订单状态：</span></th>
                        <td><span :style="{color: orderinfo.status != 4 && orderinfo.status != 5 && orderinfo.status != 6 ? '#FF8000' : ''}">{{orderinfo.statusname}}</span></td>
                        <th><span>订单金额：</span></th>
                        <td><span>￥{{orderinfo.allcost}}</span><small style="color: #999;" v-if="orderinfo.ordertype == 1"> {{orderinfo.ordertypename}}</small></td>
                    </tr>
                    <tr>
                        <th><span>订单时间：</span></th>
                        <td><span>{{orderinfo.addtime}}</span></td>
                        <th><span>付款状态：</span></th>
                        <td><span :style="{color: orderinfo.fundstatus != 4 && orderinfo.fundstatus != 5 ? '#FF8000' : ''}">{{orderinfo.fundstatusname}}</span></td>
                        <th><span>待付金额：</span></th>
                        <td><span>￥{{orderinfo.waitcost}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)">订货详情</li>
                <li class="active">出库/发货/物流</li>
                <li @click="orderjump(3)">付款记录</li>
            </ul>
        </div>
        <div class="orderdetails_box">
            <div class="orderdetails_table_content pad0" style="margin-top: 20px;">
                <Table
                    border
                    ref="selection"
                    :columns="thead"
                    :data="orderinfo.det"></Table>
            </div>
            <div class="logistics_content" v-for="(item, index) in goodslist" :key="index">
                <div class="logistics_head_content" v-if="item.status != 1">
                    <div class="logistics_head_left">
                        <div class="logistics_head_number"><h3>{{item.chukudno}}</h3></div>
                        <div class="logistics_head_list">
                            <span>状态：<span :style="{color: item.status < 4 ? '#FF8000' : ''}">{{item.statusname}}</span></span>
                            <span>出库时间：{{item.outstocktimeformat}}</span>
                        </div>
                        <div class="logistics_head_list" v-if="item.status == 5">
                            <span>取消时间：{{item.overtimeformat}}</span>
                            <span>取消原因： {{item.reason}}</span>
                        </div>
                        <div class="logistics_head_list" v-if="item.status > 2 && item.status < 5">
                            <span>发货时间：{{item.express_timeformat}}</span>
                            <span>物流公司：{{item.express_company}}</span>
                            <span>物流单号：{{item.express_dno}}</span>
                        </div>
                        <div class="logistics_head_list" v-if="item.status == 4">
                            <span>收货时间：{{item.overtimeformat}}</span>
                        </div>
                    </div>
                    <div class="logistics_head_right" v-if="item.status == 3">
                        <Button type="warning" @click="takeoverclick(item.id)">确认收货</Button>
                    </div>
                </div>
                <div class="orderdetails_table_content pad0">
                    <Table
                        border
                        ref="selection"
                        :columns="thead1"
                        :data="item.det"></Table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
export default {
    data() {
        return {
            orderinfo: {}, // 订单信息
            thead: [ // 表格头部
                {
                    type: 'index',
                    width: 50,
                    align: 'center',
                },
                {
                    width: 320,
                    align: 'center',
                    title: '商品',
                    key: 'goods',
                    render: (h, params) => {
                        return h('div', // 商品
                                    [
                                        h('div', // 商品图片
                                            {
                                                class: 'shoppingcart_goods_left',
                                                style: {
                                                    backgroundImage: 'url(' + params.row.goodsimg + ')'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.goto(params.row.goodsid)
                                                    }
                                                },
                                            }
                                        ),
                                        h('div', // 商品右侧信息
                                            {
                                                class: 'shoppingcart_goods_right'
                                            },
                                            [   
                                                h('Poptip',
                                                    {
                                                        props: {
                                                            trigger: 'hover',
                                                            width: '246',
                                                            wordWrap: true,
                                                            content: params.row.goodsname
                                                        }
                                                    },
                                                    [
                                                        h('span', // 商品名称
                                                            {
                                                                class: 'shoppingcart_goods_name'
                                                            },
                                                            [
                                                                h('b',
                                                                    {
                                                                        style: {
                                                                            backgroundColor: params.row.cxtype == 1 ? '#FF8000' : '#40a250',
                                                                            display: params.row.cxtype == 1 || params.row.cxtype == 2 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.cxtype == 1 ? '特价' : (params.row.cxtype == 2 ? '折扣' : '')
                                                                ),
                                                                h('b', {style: {
                                                                            backgroundColor: params.row.is_send == 1 ? '#FF8000' : '',
                                                                            display: params.row.is_send == 1 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.is_send == 1 ? '赠品' : ''
                                                                ),
                                                                h('span', params.row.goodsname)
                                                            ]
                                                        ),
                                                    ]
                                                ),
                                                h('small', // 商品编号
                                                    '商品编号：' + params.row.commcode
                                                )
                                            ]
                                        ),
                                    ]
                                )
                    }
                },
                {
                    align: 'center',
                    title: '规格',
                    key: 'gg_attrname'
                },
                {
                    align: 'center',
                    title: '换算关系',
                    key: 'unit',
                    render: (h, params) => {
                        if (params.row.maxunit != '') {
                            return h('span', '1' + params.row.maxunit + '=' + params.row.matrixing + params.row.unit)
                        }
                    }
                },
                {
                    align: 'center',
                    title: '单位',
                    key: 'goodsdanwei',
                    render: (h, params) => {
                        return h('span', params.row.unit)
                    }
                },
                {
                    align: 'center',
                    title: '订购数量',
                    key: 'danweiinstro',
                    render: (h, params) => {
                        return h('span', params.row.danweiinstro == '' ? (params.row.ordernum + params.row.unit) : params.row.danweiinstro)
                    }
                },
                {
                    align: 'center',
                    title: '已出库数',
                    key: 'sendcount'
                },
                {
                    align: 'center',
                    title: '待出库数',
                    key: 'staynum',
                    render: (h, params) => {
                        return h('span', params.row.ordernum - params.row.sendcount)
                    }
                }
            ],
            thead1: [ // 表格头部
                {
                    type: 'index',
                    width: 50,
                    align: 'center',
                },
                {
                    width: 320,
                    align: 'center',
                    title: '商品',
                    key: 'goods',
                    render: (h, params) => {
                        return h('div', // 商品
                                    [
                                        h('div', // 商品图片
                                            {
                                                class: 'shoppingcart_goods_left',
                                                style: {
                                                    backgroundImage: 'url(' + params.row.img + ')'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.goto(params.row.goodsid)
                                                    }
                                                },
                                            }
                                        ),
                                        h('div', // 商品右侧信息
                                            {
                                                class: 'shoppingcart_goods_right'
                                            },
                                            [   
                                                h('Poptip',
                                                    {
                                                        props: {
                                                            trigger: 'hover',
                                                            width: '246',
                                                            wordWrap: true,
                                                            content: params.row.goodsname
                                                        }
                                                    },
                                                    [
                                                        h('span', // 商品名称
                                                            {
                                                                class: 'shoppingcart_goods_name'
                                                            },
                                                            params.row.goodsname
                                                        ),
                                                    ]
                                                ),
                                                h('small', // 商品编号
                                                    '商品编号：' + params.row.goodscode
                                                )
                                            ]
                                        ),
                                    ]
                                )
                    }
                },
                {
                    align: 'center',
                    title: '规格',
                    key: 'goodsattr'
                },
                {
                    align: 'center',
                    title: '换算关系',
                    key: 'unit',
                    render: (h, params) => {
                        if (params.row.goodsfdanwei != '') {
                            return h('span', '1' + params.row.goodsfdanwei + '=' + params.row.danweibi + params.row.goodsdanwei)
                        }
                    }
                },
                {
                    align: 'center',
                    title: '单位',
                    key: 'goodsdanwei'
                },
                {
                    align: 'center',
                    title: '订购数量',
                    key: 'danweiinstro',
                    render: (h, params) => {
                        return h('span', params.row.danweiinstro == '' ? (params.row.ordernum + params.row.goodsdanwei) : params.row.danweiinstro)
                    }
                },
                {
                    align: 'center',
                    title: '本次发货数',
                    key: 'acount'
                }
            ],
            goodslist: [], // 表格列表
        }
    },
    methods: {
        getInfo () { // 获取列表
            this.http.post(api.loginsics, {id: this.$route.params.id})
            .then(response => {
                console.log(response.data.msg)
                this.orderinfo = response.data.msg.orderinfo
                this.goodslist = response.data.msg.ordersendlist
            })
            .catch(error => {
                console.log(error);
            })
        },
        orderjump (sign) { // 跳转链接
            let links
            if (sign == 1) {
                links = '订货详情'
            } else if (sign == 2) {
                links = '出库/发货/物流'
            } else if (sign == 3) {
                links = '付款记录'
            }
            this.$router.push({
                name: links,
                id: this.$route.params.id
            })
        },
        goto (id) { // 跳转商品详情页
            this.$router.push({
                name: '商品详情',
                params: {
                    id: id
                }
            })
        },
        takeoverclick (id) { // 确认收货
            this.http.post(api.takeover,
                {
                    orderid: this.$route.params.id,
                    sendid: id,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                this.$Message.success('收货成功')
                this.getInfo()
            })
            .catch(error => {
                this.$Message.error(error);
            })
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.logistics_head_content {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    padding-top: 10px;
}

.logistics_head_number {
    padding-top: 10px;
}

.logistics_head_number > h3 {
    font-size: 14px;
    color: #0C1F6D;
}

.logistics_head_list {
    padding-top: 4px;
}

.logistics_head_list > span {
    margin-right: 10px;
    font-size: 14px;
    color: #333;
}

.logistics_content .orderdetails_table_content {
    margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/order/logistics.vue